import greenFoot from "./greenFoot.png";
import "./styles.css";

export default function GreenFoot() {
    return (
        <img src={greenFoot} alt="Hojas decorativas" className="greenfoot-image"/>
    );
};